import TripModel from '../models/TripModel';
import BaseStore from './BaseStore';
import {observable, toJS} from "mobx/lib/mobx";
import { action, computed } from 'mobx';

class TripStore extends BaseStore {
  constructor(transportLayer) {
    super(TripModel, transportLayer);
  }

  @observable stationData = {
    station_id: '',
    duration:'',
    previous_stationId:''
  };
  @observable toDeleteStationId = ''

  @action
  updateStationData(data) {
      this.stationData.station_id = data.station_id;
      this.stationData.duration = data.duration;
      this.stationData.previous_stationId = data.prevStationId;
  }
}

export default TripStore;



// WEBPACK FOOTER //
// ./src/stores/TripStore.js